<template>
  <div>
    <!-- Start form -->
    <div class="container-fluid py-5">
      <div class="row">
        <div class="col-12 col-md-8 mx-auto">
          <div class="lpg-form px-3">
            <div class="mb-5">
              <h1 class="lpg-form-title fs-1 mb-1">Registro de Candidatos</h1>
              <p class="lpg-title fs-3 text-secondary mb-4">Nuevas oportunidades esperan por ti.</p>
            </div>
            <div>
              <div class="lpg-stepper d-flex justify-content-between position-relative">
                <div class="lpg-step-line"></div>
                <a
                  @click="currentStep = 1"
                  :class="['lpg-step clickable', currentStep === 1 ? 'active' : '']"
                  >1</a
                >
                <a
                  @click="currentStep = 2"
                  :class="['lpg-step clickable', currentStep === 2 ? 'active' : '']"
                  >2</a
                >
                <a
                  @click="currentStep = 3"
                  :class="['lpg-step clickable', currentStep === 3 ? 'active' : '']"
                  >3</a
                >
              </div>

              <!-- Steps -->
              <div>
                <PasoUno
                  v-if="currentStep === 1"
                  :formdata="content.profile"
                  @update-content="updateContent"
                ></PasoUno>
                <PasoDos
                  v-if="currentStep === 2"
                  :form_data="stepTwoFormData"
                  :options_data="{
                    education: {
                      educational_degrees_options,
                      educational_institutions_options,
                      study_fields_options,
                    },
                    language: {
                      language_options,
                      language_proficiency_options,
                    },
                  }"
                  @update-content="updateContent"
                ></PasoDos>
                <PasoTres
                  v-if="isLastStep"
                  :isLoading="isUploadingProfile"
                  @upload-profile="
                    isUploadingProfile = true
                    uploadProfile()
                  "
                ></PasoTres>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End form -->
  </div>
</template>

<script>
import Layout from '@/Layouts/Layout'
import PasoUno from '@/Components/CrearPerfil/PasoUno.vue'
import PasoDos from '@/Components/CrearPerfil/PasoDos.vue'
import PasoTres from '@/Components/CrearPerfil/PasoTres.vue'

export default {
  name: 'CreateApplicantProfile',
  layout: Layout,
  components: {
    PasoUno,
    PasoDos,
    PasoTres,
  },
  props: {
    errors: Object,
    profile: Object,
    educational_degrees_options: Array,
    educational_institutions_options: Array,
    study_fields_options: Array,
    language_options: Array,
    language_proficiency_options: Array,
  },
  data() {
    return {
      isUploadingProfile: false,
      currentStep: 1,
      lastStep: 3,
      content: {
        profile: this.profile,
        education: [],
        languages: [],
        job_experience: [],
      },
    }
  },
  methods: {
    handleNextStep() {
      if (this.currentStep < this.lastStep) this.currentStep++
    },
    handlePrevStep() {
      if (this.currentStep > 1) this.currentStep--
    },
    cleanNullValuesFromObject(objectToClean) {
      return Object.entries(objectToClean).reduce((prev, [key, value]) => {
        if (value !== '' && value !== null) prev[key] = value
        return prev
      }, {})
    },
    cleanContent() {
      const cleanNullValuesFromObject = this.cleanNullValuesFromObject
      return Object.entries(this.content).reduce(
        function(reducedObject, [key, value]) {
          if (key === 'profile') {
            // Clean profile object
            reducedObject.profile = {
              name: value.name,
              lastname: value.lastname,
              personal_id: value.personal_id,
              date_of_birth: value.date_of_birth,
              gender: value.gender,
            }
            reducedObject.profile = cleanNullValuesFromObject(reducedObject.profile)
          } else if (
            Array.isArray(value) &&
            ['education', 'languages', 'job_experience'].includes(key)
          ) {
            reducedObject[key] = value.map(item => cleanNullValuesFromObject(item))
          }
          return reducedObject
        },
        {} /* <-- Initiating the reducedObject */,
      )
    },
    updateContent(contentKey, content) {
      this.content[contentKey] = content
    },
    uploadProfile() {
      console.log('Uploading')
      this.$inertia.post(this.$route('profile.update'), this.cleanContent(), {
        preserveState: true,
      })
    },
  },
  computed: {
    isLastStep() {
      return this.currentStep === this.lastStep
    },
    stepTwoFormData() {
      return {
        education: this.content.education,
        languages: this.content.languages,
        job_experience: this.content.job_experience,
      }
    },
  },
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
